export default {
  token: null,
  userId: null,
  sessionGUID: null,
  sessionStamp: null,
  isCis: false,
  fees: false,
  geolocation: '',
  allowedgeo: false,
  allowedpv: true,
  affilate: false,
  exclusiveEnabled: true,
  landingEnabled: true,
  webOfficeMenu: false,
  powerline: false,
  isPremiumUser: false,
  countryList: [],
  hasBpo: false,
  affiliateLevel: 0,
  affiliateStatus: false,
  hotelSearchType: false,
  setWarningModalState: false
}
